<template>
  <div>
    <a-card class="contract-box" :bordered="false" title="电子合同信息">
      <a-row :span='24'>
        <a-col :span='8'>
          <a-form-model-item label='旅行社' v-bind='formItemLayout'>{{ contractInfo.travelAgency.agencyName }}
          </a-form-model-item>
        </a-col>
        <a-col :span='8'>
          <a-form-model-item label='旅行社业务经营许可证编号/社会统一信用代码'
                             v-bind='{ labelCol: {span: 14},wrapperCol: {span: 10}}'>
            {{ contractInfo.travelAgency.travelAgencyLicenseNumber }}/{{ contractInfo.travelAgency.businessLicenseNumber }}
          </a-form-model-item>
        </a-col>
        <a-col :span='8'>
          <a-form-model-item label='合同编号' v-bind='formItemLayout'>
            {{ contractInfo.contractCode }}
          </a-form-model-item>
        </a-col>
        <img v-if="contractInfo.contractQrCode" class="img" :src="contractInfo.contractQrCode" alt>
      </a-row>
      <a-row :span='24'>
        <a-col :span='8'>
          <a-form-model-item label='计划名称' v-bind='formItemLayout'>
            {{ contractInfo.itinerary.routeName }}-{{ contractInfo.planName }}
          </a-form-model-item>
        </a-col>
        <a-col :span='8'>
        </a-col>
        <a-col :span='8'>
          <a-form-model-item label='团队编号' v-bind='formItemLayout'>{{ contractInfo.touristCode }}</a-form-model-item>
        </a-col>
      </a-row>
      <a-row :span='24'>
        <a-col :span='8'>
          <a-form-model-item label='行程时间' v-bind='formItemLayout'>{{ contractInfo.touristBetweenTime }}
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :span='24'>
        <a-col :span='8'>
          <a-form-model-item label='旅游费用合计' required v-bind='formItemLayout'>{{ contractInfo.cost.totalCost }}元
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :span='24'>
        <a-col :span='8'>
          <a-form-model-item label='旅游费用支付方式' required v-bind='formItemLayout'>
            <a-select :disabled="isDisabled" v-model="contractInfo.cost.paymentMethod" placeholder="请选择" allowClear
                      style="width: 183px;">
              <a-select-option :value="1">现金</a-select-option>
              <a-select-option :value="2">转账</a-select-option>
              <a-select-option :value="3">线上支付</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :span='24'>
        <a-col :span='8'>
          <a-form-model-item label='旅游费用支付时间' required v-bind='formItemLayout'>
            <a-date-picker :disabled="isDisabled" v-model="hotelOpenTime" @change="onDateChange"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <div class="title required-title">人身意外伤害保险</div>
      <div class="content-box">
        <span>1、旅行社提示旅游者购买人身意外伤害保险</span>
        <span>2、旅游者可以做以下选择</span>
        <a-radio-group :disabled="isDisabled" class="text-box" v-model="contractInfo.insurance.purchaseMethod">
          <a-radio :value="1">
            1、委托旅行社购买（旅行社不具有保险兼业代理资格的，不得勾选此项）；保险产品名称
            <a-input :disabled="isDisabled" v-model="contractInfo.insurance.productName"
                     placeholder="请输入购买的保险产品名称" style="width: 250px;"/>
            （投保的相关信息以实际保单为准）；
          </a-radio>
          <br/>
          <a-radio :value="2">
            2、自行购买；
          </a-radio>
          <br/>
          <a-radio :value="3">
            3、放弃购买；
          </a-radio>
          <br/>
          <a-radio :value="4">
            4、同意旅行社赠送人身意外险；
          </a-radio>
        </a-radio-group>
      </div>
      <div class="title required-title">成团人数与不成团约定</div>
      <div class="content-box">
        <div style="margin-bottom: 5px">
          成团的最低人数
          <a-input :disabled="isDisabled" v-model="contractInfo.groupAgreement.leastCustomerNumber" placeholder="人数"
                   style="width: 60px;"/>
          人。 如不能成团，旅游者按以下第
          <a-select :disabled="isDisabled" v-model="contractInfo.groupAgreement.resolution" placeholder="请选择"
                    allowClear style="width: 100px;">
            <a-select-option :value="1">1</a-select-option>
            <a-select-option :value="2">2</a-select-option>
            <a-select-option :value="3">3</a-select-option>
            <a-select-option :value="4">4</a-select-option>
          </a-select>
          种方式解决；
        </div>
        <a-radio-group :disabled="isDisabled" class="text-box" v-model="contractInfo.groupAgreement.resolution">
          <a-radio :value="1">
            1、旅行社委托；
            <a-input :disabled="isDisabled" v-model="contractInfo.groupAgreement.transferToCompanyName"
                     placeholder="请输入要委托的旅行社名称" style="width: 300px;"/>
            旅行社履行合同；
          </a-radio>
          <br/>
          <a-radio :value="2">
            2、延期出团；
          </a-radio>
          <br/>
          <a-radio :value="3">
            3、改签出团；
          </a-radio>
          <br/>
          <a-radio :value="4">
            4、解除合同；
          </a-radio>
        </a-radio-group>
      </div>
      <div class="title required-title">拼团约定</div>
      <div class="content-box">
        <div style="margin-bottom: 5px">
          旅游者：
          <a-select :disabled="isDisabled" v-model="agreeToMerge" placeholder="请选择" allowClear style="width: 100px;"
                    @change="agreeToMergeChange">
            <a-select-option value="1">同意</a-select-option>
            <a-select-option value="2">不同意</a-select-option>
          </a-select>
          (同意或不同意)采用拼团方式至
          <a-input :disabled="isDisabled" v-model="contractInfo.groupAgreement.mergeToCompanyName"
                   placeholder="请输入拼团旅行社名称" style="width: 300px;"/>
          旅行社出团；
        </div>
      </div>
      <div class="title">争议解决方式</div>
      <div class="content-box">
        <div style="margin-bottom: 5px">
          本合同履行过程中发生争议，由双方协商解决；亦可向合同签订地的旅游质监执法机构、消费者协会、有关的调解组织等有关部门或者机构申请调解。协商或者调解不成的，按下列第
          <a-select :disabled="isDisabled" v-model="contractInfo.dispute.resolution" placeholder="请选择" allowClear
                    style="width: 100px;">
            <a-select-option :value="1">1</a-select-option>
            <a-select-option :value="2">2</a-select-option>
          </a-select>
          种方式解决；
        </div>
        <a-radio-group :disabled="isDisabled" class="text-box pd0" v-model="contractInfo.dispute.resolution">
          <a-radio :value="1">
            1、提交
            <a-input :disabled="isDisabled" v-model="contractInfo.dispute.tribunalName" placeholder="请输入"
                     style="width: 300px;"/>
            仲裁委员会仲裁；
          </a-radio>
          <br/>
          <a-radio :value="2">
            2、依法向人民法院起诉；
          </a-radio>
        </a-radio-group>
      </div>
      <div class="title">其他双方协商约定事宜</div>
      <a-textarea v-model="contractInfo.supplementaryClause" disabled :maxLength="5000"
                  :autoSize="{ minRows: 4, maxRows: 20 }"/>
    </a-card>
    <a-card :bordered="false" title="游客名单">
      <a-table rowKey="index" :columns="getColumns()" :pagination='false' :data-source="touristList">
        <template slot="customIndex" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="customInfo" slot-scope="text, record, index">
          {{ record.ocustomerInfoTypeStr }}({{ record.price }})
        </template>
      </a-table>
    </a-card>
    <a-card :bordered="false" title="合同签署信息">
      <div class="info-box">
        <div class="info-item">
          <div class="info-title">游客</div>
          <div class="content-box">
            <div class="content-item">
              <span class="item-title item-require-title">订单来源类型</span>
              <div class="item-content">
                <a-radio-group :disabled="isDisabled" v-model="ruleForm.value">
                  <a-radio :value="1">个人客户</a-radio>
                </a-radio-group>
              </div>
            </div>
            <div class="content-item">
              <span class="item-title item-require-title">合同签署代表</span>
              <div class="item-content">
                <a-input :disabled="isDisabled" v-model="contractInfo.signatory.name" placeholder="请输入合同签署代表"
                         style="width: 100%;"/>
              </div>
            </div>
            <div class="content-item">
              <div class="item-title item-require-title">
                <a-select :disabled="isDisabled" v-model="contractInfo.signatory.ID.IDType" placeholder="请选择"
                          allowClear style="width: 100px;">
                  <a-select-option :value="1">身份证</a-select-option>
                  <a-select-option :value="2">士官证</a-select-option>
                  <a-select-option :value="3">港澳通行证</a-select-option>
                  <a-select-option :value="4">护照</a-select-option>
                  <a-select-option :value="5">赴台证</a-select-option>
                  <a-select-option :value="6">回乡证</a-select-option>
                  <a-select-option :value="7">台胞证</a-select-option>
                  <a-select-option :value="8">其它</a-select-option>
                </a-select>
              </div>
              <div class="item-content">
                <a-input :disabled="isDisabled" v-model="contractInfo.signatory.ID.IDNumber"
                         placeholder="请输入证件号码" style="width: 100%;"/>
              </div>
            </div>
            <div class="content-item">
              <span class="item-title item-require-title">联系电话</span>
              <div class="item-content">
                <a-input :disabled="isDisabled" v-model="contractInfo.signatory.phone" placeholder="请输入联系电话"
                         style="width: 100%;"/>
              </div>
            </div>
            <div class="content-item">
              <span class="item-title item-require-title">联系地址</span>
              <div class="item-content">
                <a-input :disabled="isDisabled" v-model="contractInfo.signatory.address.description"
                         placeholder="请输入联系地址" style="width: 100%;"/>
              </div>
            </div>
            <div class="content-item">
              <span class="item-title">电子邮箱</span>
              <div class="item-content">
                <a-input :disabled="isDisabled" v-model="contractInfo.signatory.email" placeholder="请输入电子邮箱"
                         style="width: 100%;"/>
              </div>
            </div>
          </div>
          <div class="info-title mt20">出境社监督、投诉电话：0755-26603339</div>
        </div>
        <div class="info-item">
          <div class="info-title">旅行社</div>
          <div class="content-box">
            <div class="content-item">
              <span class="item-title item-require-title">旅行社盖章</span>
              <div class="item-content">需登陆全国旅游监管平台生成电子章</div>
            </div>
            <div class="content-item">
              <span class="item-title item-require-title">经办人</span>
              <div class="item-content">
                <a-input :disabled="isDisabled" v-model="contractInfo.travelAgency.transactorName"
                         placeholder="请输入经办人" style="width: 100%;"/>
              </div>
            </div>
            <div class="content-item">
              <span class="item-title item-require-title">营业地址</span>
              <div class="item-content">
                <a-input :disabled="isDisabled" v-model="contractInfo.travelAgency.agencyAddress.description"
                         placeholder="请输入营业地址" style="width: 100%;"/>
              </div>
            </div>
            <div class="content-item">
              <span class="item-title item-require-title">座机/手机</span>
              <div class="item-content">
                <a-input :disabled="isDisabled" v-model="contractInfo.travelAgency.transactorPhone"
                         placeholder="请输入座机/手机" style="width: 100%;"/>
              </div>
            </div>
            <div class="content-item">
              <span class="item-title">电子邮箱</span>
              <div class="item-content">
                <a-input :disabled="isDisabled" v-model="contractInfo.travelAgency.email" placeholder="请输入电子邮箱"
                         style="width: 100%;"/>
              </div>
            </div>
            <div class="content-item">
              <span class="item-title item-require-title">签约日期</span>
              <div class="item-content">{{ contractInfo.signTime }}</div>
            </div>
          </div>
          <div class="info-title mt20">深圳市旅游质监执法电话：12315、12301</div>
        </div>
      </div>
      <div class="btn-box">
        <template v-if="type === '1'">
          <a-button class="mr10" type="primary" :loading="saveLoading" @click="saveEvent">保存</a-button>
          <a-button class="mr10" type="primary" :loading="sureLoading" @click="sureEvent">确认签署</a-button>
          <a-button type="primary" @click="cancelEvent">关闭</a-button>
        </template>
        <template v-if="type === '2'">
          <!-- 按钮显示
              合同状态 1待签属[待客户签暑合同](签署中) 2已签署 3作废中[待用户同意作废] 4已作废[用户已同意作废] ,
              签署中：预览合同、下载合同、重发签署短信、关闭。
              已签署：预览合同、作废合同、下载合同、关闭。
              作废中：预览合同、下载合同、重发作废短信、关闭。
              已作废：预览合同、下载合同、关闭。
          -->
          <a-button class="mr10" type="primary" @click="previewEvent">预览合同</a-button>
          <a-button v-if="contractSignStatus === '2'" class="mr10" type="primary" :loading="invalidLoading"
                    @click="invalidEvent">作废合同
          </a-button>
          <a-button class="mr10" type="primary" @click="uploadEvent">下载合同</a-button>
          <a-button v-if="contractSignStatus === '1'" class="mr10" type="primary" :loading="resendLoading"
                    @click="resendEvent">重发签署短信
          </a-button>
          <a-button v-if="contractSignStatus === '3'" class="mr10" type="primary" :loading="resendInvalidLoading"
                    @click="resendInvalidEvent">重发作废短信
          </a-button>
          <a-button type="primary" @click="cancelEvent">关闭</a-button>
        </template>
      </div>
    </a-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { formatFullDate } from '@/utils/common.js'
import moment from 'moment'
import downLoadHelper from '@/utils/helper/downLoadHelper'

const templateIdList = {  // 12301合同模板类型id A00001 – 境内游 C00001 – 出境游 D00001 – 一日游 F00001 – 赴台游 E00001 – 代订代办 ,
  // 73出境游 74国内游
  '73': 'C00001',
  '74': 'A00001'
}
export default {
  name: 'ElectronicContractDetail',
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 6
        },
        wrapperCol: {
          span: 18
        }
      },
      ruleForm: {
        value: 1
      },
      hotelOpenTime: '', // 旅游费用支付时间
      touristList: [],
      type: '1', // 1-创建 2-详情
      orderNoList: [],
      proCatalog: '', // 商品类型Id 73出境游 74国内游
      contractInfo: {
        travelAgency: {
          agencyAddress: {
            description: ''
          }
        },
        cost: {},
        itinerary: {},
        insurance: {
          purchaseMethod: undefined
        },
        touristsInfo: {},
        groupAgreement: {},
        dispute: {},
        signatory: {
          ID: {},
          address: {}
        }
      }, // 合同草稿
      templateIdList,
      saveLoading: false,
      sureLoading: false,
      resendLoading: false,
      invalidLoading: false,
      resendInvalidLoading: false,
      agreeToMerge: '',
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      touristContractId: '',
      contractSignStatus: '', // 合同状态 1待签属[待客户签暑合同] 2已签署 3作废中[待用户同意作废] 4已作废[用户已同意作废] ,
      isDisabled: false // 禁用 => 详情进来-禁用
    }
  },
  async created() {
    this.type = this.$route.query.type
    this.isDisabled = this.type === '2'
    this.proCatalog = this.$route.query.proCatalog
    this.touristContractId = this.$route.query.touristContractId
    this.orderNoList = JSON.parse(this.$route.query.orderNoList)
    let orderDetail = await this.getDetail() || { contractCustomList: [] }
    this.contractSignStatus = String(this.$route.query.contractSignStatus)
    if (this.type === '1') { // 创建
      this.contractInfo = await this.getOrderCodesContract()
    } else { // 详情
      this.contractInfo = await this.getContractDetail()
    }
    if (!this.contractInfo.touristContractId) { // 没保存过草稿箱(第一次创建合同)
      let contractCustomList = orderDetail.contractCustomList
      let tourists = []
      if (orderDetail.contractCustomList && orderDetail.contractCustomList.length) {
        tourists = contractCustomList.map((item, index) => {
          return {
            phone: item.ocustomerInfoPhone,
            ID: {
              IDNumber: item.ocustomerInfoIdCard,
              IDType: item.ocustomerInfoCardType
            },
            name: item.ocustomerInfoName,
            number: index + 1,
            isChild: item.ocustomerInfoTypeStr === '儿童'
          }
        })
      }
      this.contractInfo = {
        ...this.contractInfo,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        groupAgreement: {},
        orderCodes: this.orderNoList,
        signatory: {
          ID: {},
          address: {}
        },
        signTime: formatFullDate(new Date(), true),
        touristsInfo: {
          totalNumber: tourists.length,
          tourists: tourists
        },
        cost: {
          paymentTime: orderDetail.orderConfirmTime,
          totalCost: orderDetail.orderPaidFeeTotal,
          paymentMethod: 3,
          adultCost: orderDetail.orderPriceSelling,
          childCost: orderDetail.orderPriceChildSelling,
          singleSupplementCost: orderDetail.orderPriceRoomDis
        },
        itinerary: {
          endDate: orderDetail.orderDepartureDate,
          routeName: orderDetail.orderMainProName,
          startDate: orderDetail.orderTravelDate,
          days: this.calculateDaysAndNights('days', orderDetail.orderTravelDate, orderDetail.orderDepartureDate),
          nights: this.calculateDaysAndNights('nights', orderDetail.orderTravelDate, orderDetail.orderDepartureDate)
        },
        insurance: {
          purchaseMethod: undefined
        },
        planName: orderDetail.orderOptionName,
        touristCode: orderDetail.teamNo,
        templateId: templateIdList[this.proCatalog],
        touristBetweenTime: orderDetail.orderTravelDate + '至' + orderDetail.orderDepartureDate
      }
      this.touristList = contractCustomList || []
      if (this.touristList.length) {
        this.touristList.forEach((item, index) => {
          item.index = index + 1
        })
      }
      this.agreeToMerge = this.contractInfo.groupAgreement.agreeToMerge ? '1' : '2'
      this.hotelOpenTime = this.contractInfo.cost.paymentTime ? moment(this.contractInfo.cost.paymentTime, 'YYYY-MM-DD') : undefined
    } else {
      this.touristList = orderDetail.contractCustomList || []
      if (this.touristList.length) {
        this.touristList.forEach((item, index) => {
          item.index = index + 1
          item.gender = this.contractInfo.touristsInfo.tourists[index].gender
        })
      }
      this.agreeToMerge = this.contractInfo.groupAgreement.agreeToMerge ? '1' : '2'
      this.hotelOpenTime = this.contractInfo.cost.paymentTime ? moment(this.contractInfo.cost.paymentTime, 'YYYY-MM-DD') : undefined
    }
  },
  methods: {
    calculateDaysAndNights(type, sDate, eDate) {
      const startDate = moment(sDate)
      const endDate = moment(eDate)
      const days = endDate.diff(startDate, 'days') + 1
      const nights = endDate.diff(startDate, 'days')
      if (type === 'days') {
        return days <= 0 ? 1 : days
      } else if (type === 'nights') {
        return nights <= 0 ? 0 : nights
      }
    },
    getDetail() {
      return new Promise(resolve => {
        this.getHttpServices().getOrderService().post('contract/detailByOrder', {
          orderNoList: this.orderNoList
        }).then(res => {
          resolve(res)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => resolve())
      })
    },
    getOrderCodesContract() { // 合同草稿
      return new Promise(resolve => {
        this.getHttpServices().getServerApiService().post('tourist/contract/getOrderCodesContract', {
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId,
          proCatalog: this.proCatalog,
          orderCodes: this.orderNoList
        }).then(res => {
          resolve(res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      })
    },
    getContractDetail() {
      return new Promise(resolve => {
        this.getHttpServices().getServerApiService().post('tourist/contract/contractDetail', {
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId,
          touristContractId: this.touristContractId
        }).then(res => {
          resolve(res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      })
    },
    onDateChange(date, dateString) {
      this.hotelOpenTime = date
      this.contractInfo.cost.paymentTime = dateString
    },
    getColumns() {
      return [
        {
          title: '序号',
          dataIndex: 'customIndex',
          scopedSlots: { customRender: 'customIndex' }
        },
        {
          title: '价格类型',
          scopedSlots: { customRender: 'customInfo' }
        },
        {
          title: '姓名',
          dataIndex: 'ocustomerInfoName'
        },
        {
          title: '性别',
          dataIndex: ''
        },
        {
          title: '手机号',
          dataIndex: 'ocustomerInfoPhone'
        },
        {
          title: '证件类型',
          dataIndex: 'ocustomerInfoCardTypeStr'
        },
        {
          title: '证件号码',
          dataIndex: 'ocustomerInfoIdCard'
        }
      ]
    },
    agreeToMergeChange(e) {
      this.contractInfo.groupAgreement.agreeToMerge = e === '1'
    },
    cancelEvent() {
      this.backEvent()
      let listType = this.type === '1' ? 2 : 1
      Vue.ls.set('list_type', listType)
    },
    verifyEvent() {
      let verify = true
      if (!this.contractInfo.cost.paymentMethod) {
        verify = false
        this.$message.error('请选择旅游费用支付方式')
        return verify
      }
      if (!this.contractInfo.cost.paymentTime) {
        verify = false
        this.$message.error('请选择旅游费用支付时间')
        return verify
      }
      if (!this.contractInfo.insurance.purchaseMethod) {
        verify = false
        this.$message.error('请选择人身意外伤害保险')
        return verify
      } else if (this.contractInfo.insurance.purchaseMethod === 1 && !this.contractInfo.insurance.productName) {
        verify = false
        this.$message.error('请输入购买的保险产品名称')
        return verify
      }
      if (!this.contractInfo.groupAgreement.leastCustomerNumber && this.contractInfo.groupAgreement.leastCustomerNumber != 0) {
        verify = false
        this.$message.error('请输入成团的最低人数')
        return verify
      } else if (this.contractInfo.groupAgreement.leastCustomerNumber && !/^[0-9]\d*$/.test(this.contractInfo.groupAgreement.leastCustomerNumber)) {
        verify = false
        this.$message.error('成团的最低人数只能输入数字')
        return verify
      } else if (this.contractInfo.groupAgreement.leastCustomerNumber && this.contractInfo.groupAgreement.leastCustomerNumber == 0) {
        verify = false
        this.$message.error('成团的最低人数不能为0')
        return verify
      }
      if (!this.contractInfo.groupAgreement.resolution) {
        verify = false
        this.$message.error('请选择不能成团时的解决方式')
        return verify
      } else if (this.contractInfo.groupAgreement.resolution === 1 && !this.contractInfo.groupAgreement.transferToCompanyName) {
        verify = false
        this.$message.error('请输入要委托的旅行社名称')
        return verify
      }
      if (!this.agreeToMerge) {
        verify = false
        this.$message.error('请选择是否同意拼团方式')
        return verify
      } else if (this.agreeToMerge === '1' && !this.contractInfo.groupAgreement.mergeToCompanyName) {
        verify = false
        this.$message.error('请输入拼团旅行社名称')
        return verify
      }
      if (!this.contractInfo.dispute.resolution) {
        verify = false
        this.$message.error('请选择争议解决方式')
        return verify
      } else if (this.contractInfo.dispute.resolution === 1 && !this.contractInfo.dispute.tribunalName) {
        verify = false
        this.$message.error('争议解决信息')
        return verify
      }
      if (!this.contractInfo.signatory.name) {
        verify = false
        this.$message.error('请输入合同签署代表')
        return verify
      }
      if (!this.contractInfo.signatory.ID.IDType) {
        verify = false
        this.$message.error('请选择游客证件类型')
        return verify
      } else if (this.contractInfo.signatory.ID.IDType && !this.contractInfo.signatory.ID.IDNumber) {
        verify = false
        this.$message.error('请输入游客证件号码')
        return verify
      }
      if (!this.contractInfo.signatory.phone) {
        verify = false
        this.$message.error('请输入游客联系电话')
        return verify
      } else if (this.contractInfo.signatory.phone && !/^1[3456789]\d{9}$/.test(this.contractInfo.signatory.phone)) {
        verify = false
        this.$message.error('游客联系电话格式有误')
        return verify
      }
      if (!this.contractInfo.signatory.address.description) {
        verify = false
        this.$message.error('请输入游客联系地址')
        return verify
      }
      if (this.contractInfo.signatory.email && !/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(this.contractInfo.signatory.email)) {
        verify = false
        this.$message.error('游客电子邮箱格式有误')
        return verify
      }
      if (!this.contractInfo.travelAgency.transactorName) {
        verify = false
        this.$message.error('请输入旅行社经办人')
        return verify
      }
      if (!this.contractInfo.travelAgency.agencyAddress.description) {
        verify = false
        this.$message.error('请输入旅行社营业地址')
        return verify
      }
      if (!this.contractInfo.travelAgency.transactorPhone) {
        verify = false
        this.$message.error('请输入旅行社座机/手机')
        return verify
      }
      if (this.contractInfo.travelAgency.email && !/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(this.contractInfo.travelAgency.email)) {
        verify = false
        this.$message.error('游客电子邮箱格式有误')
        return verify
      }
      return verify
    },
    saveEvent() { // 保存
      let isVerify = this.verifyEvent()
      if (isVerify) {
        if (!this.saveLoading) {
          this.saveLoading = true
          this.getHttpServices().getServerApiService().post('tourist/contract/saveTempContract', this.contractInfo).then(res => {
            this.$message.success('保存成功')
            this.cancelEvent()
          }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
        }
      }
    },
    sureEvent() { // 确认签署
      let isVerify = this.verifyEvent()
      if (isVerify) {
        if (!this.sureLoading) {
          this.sureLoading = true
          this.getHttpServices().getServerApiService().post('tourist/contract/sureSignContract', this.contractInfo).then(res => {
            this.$message.success('确认签署成功')
            this.cancelEvent()
          }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.sureLoading = false)
        }
      }
    },
    resendEvent() { // 重发签署短信
      if (!this.resendLoading) {
        this.resendLoading = true
        this.getHttpServices().getServerApiService().post('tourist/contract/resend', {
          merchantId: this.contractInfo.merchantId,
          platformId: this.contractInfo.platformId,
          touristContractId: this.contractInfo.touristContractId
        }).then(() => {
          this.$message.success('重发签署短信成功')
          this.cancelEvent()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.resendLoading = false)
      }
    },
    resendInvalidEvent() { // 重发作废短信
      if (!this.resendInvalidLoading) {
        this.resendInvalidLoading = true
        this.getHttpServices().getServerApiService().post('tourist/contract/resendInvalid', {
          merchantId: this.contractInfo.merchantId,
          platformId: this.contractInfo.platformId,
          touristContractId: this.contractInfo.touristContractId
        }).then(() => {
          this.$message.success('重发作废短信成功')
          this.cancelEvent()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.resendInvalidLoading = false)
      }
    },
    previewEvent() { // 预览合同
      window.open(this.contractInfo.fileUrl)
    },
    invalidEvent() { // 作废合同
      if (!this.invalidLoading) {
        this.invalidLoading = true
        this.getHttpServices().getServerApiService().post('tourist/contract/invalidContract', {
          merchantId: this.contractInfo.merchantId,
          platformId: this.contractInfo.platformId,
          touristContractId: this.contractInfo.touristContractId
        }).then(res => {
          this.$message.success('作废合同成功')
          this.cancelEvent()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.invalidLoading = false)
      }
    },
    uploadEvent() { // 下载合同
      let name = `${this.contractInfo.contractCode}.pdf`
      let url = `${this.getAppConfig().serviceUrl}/tourist/contract/download?platformId=${this.platformId}&merchantId=${this.merchantId}&touristContractId=${this.contractInfo.touristContractId}`
      downLoadHelper.downloadImage(name, url)
    }
  }
}
</script>

<style lang="less" scoped>
.contract-box {
  position: relative;

  .img {
    position: absolute;
    width: 80px;
    height: 80px;
    top: 0;
    right: 20px;
  }
}

::v-deep .ant-col-lg-4 {
  width: 30%;
}

::v-deep .ant-col-lg-20 {
  width: 70%;
}

.row-box {
  ::v-deep .ant-row {
    margin-bottom: 0;
  }
}

::v-deep .ant-form-item {
  margin-bottom: 10px;
}

.title {
  color: rgba(0, 0, 0, 0.85);
  margin: 5px 0;
}

.required-title {
  position: relative;

  &:before {
    display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 14px;
    content: '*';
  }
}

.content-box {
  margin-top: 5px;
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  color: rgba(0, 0, 0, 0.85);

  .text-box {
    padding-left: 20px;
    //display: flex;
    //flex-direction: column;
  }

  .pd0 {
    padding: 0;
  }
}

::v-deep .ant-radio-wrapper {
  color: rgba(0, 0, 0, 0.85);
}

.info-box {
  display: flex;
  justify-content: space-between;

  .info-item {
    display: flex;
    flex-direction: column;
    width: 48%;

    .info-title {
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 20px;
      padding-left: 20px;
    }

    .mt20 {
      margin-top: 20px;
    }

    .content-box {
      height: 350px;
      padding: 20px 20px;
      border: 1px solid #d7d7d7;

      .content-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        .item-title {
          display: flex;
          align-items: center;
          color: rgba(0, 0, 0, 0.85);
          position: relative;
          padding-left: 10px;
          min-width: 120px;
          margin-right: 20px;

          &:after {
            display: inline-block;
            margin-left: 4px;
            color: rgba(0, 0, 0, 0.85);
            font-size: 14px;
            content: ':';
          }
        }

        .item-require-title {
          &:before {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            color: #f5222d;
            font-size: 14px;
            content: '*';
          }
        }

        .item-content {
          flex: 1;
        }
      }
    }
  }
}

.btn-box {
  margin-top: 100px;
  display: flex;
  justify-content: flex-end;
}

.mr10 {
  margin-right: 10px;
}
</style>
